var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Info } from '@phosphor-icons/react';
import cx from 'clsx';
import { visuallyHidden } from '../../css/accessibility.css';
import { styles } from './InfoButton.css';
export const InfoButton = React.forwardRef(function InfoButton(_a, ref) {
    var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
    return (_jsxs("button", Object.assign({ className: cx(styles.button, className), ref: ref, type: "button" }, rest, { children: [_jsx(Info, { "aria-hidden": true, className: styles.icon, weight: "fill" }), _jsx("span", { className: visuallyHidden, children: label })] })));
});
